export default "__VITE_ASSET__69ceb3c8__"